import axios from "axios";
import { API } from "../App";

let _causes = null;
let _pending = null;

// Canonical public domain for share links (the wall's published home)
export const SITE_HOST = "LOOKWASHINGTON.com";

// Cached fetch of active causes (the wall's carried causes)
export const getActiveCauses = () => {
  if (_causes) return Promise.resolve(_causes);
  if (!_pending) {
    _pending = axios
      .get(`${API}/cause-pages`)
      .then((r) => {
        _causes = Array.isArray(r.data) ? r.data : [];
        return _causes;
      })
      .catch(() => []);
  }
  return _pending;
};

export const causeShortPath = (cause) => cause?.short_path || `/causes/${cause?.slug || ""}`;

export const causeShortLink = (cause) => `${SITE_HOST}${causeShortPath(cause).toUpperCase()}`;

export const causeLine = (cause) =>
  cause ? `\n${cause.bumper_text}\nLearn at THE WALL: ${causeShortLink(cause)}` : "";

export const trackCauseShare = (cause) => {
  if (cause?.slug) axios.post(`${API}/causes/${cause.slug}/track-share`).catch(() => {});
};

export const suggestCause = (text, page) =>
  axios.post(`${API}/causes/suggest`, { text, page });
